<script lang="ts" module>
  export type EstimatedDeliveryProps = {
    estimation?: {
      formattedDeliveryDate: string;
      formattedPostalCode: string;
      formattedCountry: string;
    };
    onOpenLocationPicker: () => void;
    class?: string;
    size?: TextSize;
    dateInterval?: boolean;
    boldPostalCode?: boolean;
  };
</script>

<script lang="ts">
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import Trans from '@athena-lib/Trans/Trans.svelte';
  import { Text } from '@athena-lib/Text';
  import type { TextSize } from '@athena-lib/Text/Text/types';

  const {
    estimation,
    onOpenLocationPicker,
    class: className,
    size,
    dateInterval,
    boldPostalCode,
  }: EstimatedDeliveryProps = $props();

  const translations = getCommonTranslations();

  const translation = $derived(
    !dateInterval ? translations.getYourOrderOn : translations.getYourOrderBetween,
  );
</script>

{#if estimation}
  {@const { formattedDeliveryDate, formattedCountry } = estimation}

  {#snippet estimatedDelivery()}
    <Text element="span" {size} bold>{formattedDeliveryDate}</Text>
  {/snippet}

  {#snippet customerPostalCode()}
    <button type="button" onclick={onOpenLocationPicker}>
      <Text element="span" {size} class="underline" bold={boldPostalCode}>{formattedCountry}</Text>
    </button>
  {/snippet}

  <Text element="p" {size} class={className}>
    <Trans {translation} snippets={{ estimatedDelivery, customerPostalCode }} />
  </Text>
{:else}
  <button type="button" onclick={onOpenLocationPicker} class="underline"
    >{translations.setYourPostalCodeToViewDeliveryOptions}</button
  >
{/if}
